// extracted by mini-css-extract-plugin
module.exports = {"modalFooterButtons":"PaymentFormEditionModal_modalFooterButtons__3TLfC"};